import _ from "lodash";
import ACLStore from "lib/aclStore";

export const getVariablesForJumpToPermissions = ({ curriculumPrograms }) => {
  const contexts = [[]];

  const programsCount = _.size(curriculumPrograms);

  for (let i = 0; i < programsCount; i++) {
    const { id } = curriculumPrograms[i];

    const context = [
      {
        entityId: id,
        entityType: "CURRICULUM_PROGRAM",
      },
    ];

    contexts.push(context);
  }

  return {
    filters: {
      module: "TEACHER_HOMEPAGE",
      appType: ["TEACHER_WEB"],
      contexts,
    },
  };
};

export const getIsJumpToLargeOrgRevampEnabled = () =>
  ACLStore.can("JumpToLargeOrgRevamp");
